import { useState } from 'react';
import { AppBar as MuiAppBar, Toolbar, IconButton, Box, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { makeStyles } from 'tss-react/mui';
import { Icon, Typography } from '@zenput/legacy-ui-components';

const { Headline } = Typography;

const useStyles = makeStyles()((theme) => {
    const { zenputColors, spacing } = theme;

    return {
        toolbar: {
            minHeight: spacing(8),
            paddingTop: 'env(safe-area-inset-top)',
            backgroundColor: 'var(--secondary-main)'
        },
        title: {
            color: zenputColors.white,
            fontWeight: 'normal',
            fontSize: '1.25em'
        }
    };
});

const AppBar = (props) => {
    const { toolbarMenuItems, title, onGoBack } = props;
    const { classes } = useStyles();

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <MuiAppBar position="relative" elevation={1}>
            <Toolbar className={classes.toolbar}>
                <IconButton
                    className="app_bar_go_back"
                    edge="start"
                    color="inherit"
                    aria-label="menu"
                    onClick={onGoBack}
                    size="large"
                >
                    <Icon variant="df-back" />
                </IconButton>
                <Headline component="div" className={classes.title} sx={{ flexGrow: 1 }}>
                    {title}
                </Headline>
                {toolbarMenuItems && (
                    <Box sx={{ flexGrow: 0 }}>
                        <IconButton onClick={handleClick} sx={{ color: 'white' }}>
                            <MoreVertIcon />
                        </IconButton>
                        <Menu
                            id="basic-menu"
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleClose}
                            slotProps={{
                                paper: {
                                    sx: {
                                        width: (theme) => theme.spacing(30)
                                    }
                                },
                                list: {
                                    'aria-labelledby': 'basic-button'
                                }
                            }}
                        >
                            {toolbarMenuItems.map((item, index) => {
                                return (
                                    item.visible && (
                                        <MenuItem
                                            key={index + item.title}
                                            onClick={(event) => {
                                                item.onClick(event);
                                                handleClose();
                                            }}
                                            sx={{ fontSize: '1em' }}
                                        >
                                            {item.title}
                                        </MenuItem>
                                    )
                                );
                            })}
                        </Menu>
                    </Box>
                )}
            </Toolbar>
        </MuiAppBar>
    );
};

export default AppBar;
